








































import { Vue, Component, Emit, Prop } from 'vue-property-decorator'
import { EnrollConfig } from '@/models/enroll/enrollConfing'
import { randKey } from '@/utils/random'
import { ElForm } from 'element-ui/types/form'
import { put } from '@/api/enroll/enrollConfig'
import { notify } from '@/utils/notification'

@Component
export default class ConfigEditer extends Vue {
  @Prop({ type: Object, required: true }) form!: EnrollConfig

  rules = {
    name: [{ required: true, message: '请输入考试名称', trigger: 'blur' }],
    explain: [{ required: true, message: '请输入考试说明', trigger: 'blur' }],
  }

  randKey = randKey()

  async validForm(el: ElForm) {
    try {
      await el.validate()
      return true
    } catch (e) {
      return false
    }
  }

  async handleEditer() {
    if (await this.validForm(this.$refs.form as any)) {
      try {
        await put(this.form, this.form.id)
        notify('编辑设置成功')
        this.$emit('SaveSuccess')
      } catch (e) {
        notify('编辑设置失败', e)
      } finally {
        this.form = {
          id: '',
          key: '',
          title: '',
          abbr: '',
          description: '',
          disable: true,
          hidden: true,

          startTime: '',
          endTime: '',
          notice: [],
          additional: '',
        }
      }
    }
  }

  @Emit('clickReturn')
  onReturn($event: any) {
    this.form = {
      id: '',
      key: '',
      title: '',
      abbr: '',
      description: '',
      disable: true,
      hidden: true,

      startTime: '',
      endTime: '',
      notice: [],
      additional: '',
    }
    return $event
  }
}
